import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutZones extends Layout {
    sourceZones: DataSource;
    tableZones: Table;
}
